import { useState } from "react";
import { portfolioImg } from "@/lib/api";
import { PortfolioLightbox } from "@/components/supply/PortfolioLightbox";
import { CATALOG_SPOT, CATEGORY_LABEL, EXAMPLE_NOTE, usePortfolio } from "@/components/supply/portfolio";

export const CatalogExamples = ({ spot }) => {
  const all = usePortfolio();
  const [index, setIndex] = useState(null);
  const items = all.filter((p) => p.in_catalog && CATALOG_SPOT[p.category] === spot).slice(0, 4);
  if (!items.length) return null;
  return (
    <div className="mb-6" data-testid={`catalog-examples-${spot}`}>
      <div className="flex gap-3 overflow-x-auto no-scrollbar">
        {items.map((p, i) => (
          <button key={p.id} type="button" onClick={() => setIndex(i)} data-testid={`catalog-example-${spot}-${p.id}`}
                  className="shrink-0 h-28 md:h-36 overflow-hidden bg-neutral-100">
            <img src={portfolioImg(p.id)} alt={p.caption || CATEGORY_LABEL[p.category]} loading="lazy"
                 onError={(e) => { e.currentTarget.closest("button").style.display = "none"; }}
                 className="h-full w-auto block transition-transform duration-500 hover:scale-[1.04]" />
          </button>
        ))}
      </div>
      <div className="mt-2 text-xs" style={{ color: "var(--ss-muted)" }}>{EXAMPLE_NOTE}</div>
      <PortfolioLightbox items={items} index={index} setIndex={setIndex} />
    </div>
  );
};
